import AutosuggestDropdownItem from './AutosuggestDropdownItem';

export default AutosuggestDropdownItem;
